import { getDefaultExportFromCjs } from './_virtual-_commonjsHelpers.js';
import { __require as requireIsRetryAllowed } from './node_modules-is-retry-allowed-index.js';

var isRetryAllowedExports = requireIsRetryAllowed();
var isRetryAllowed = /*@__PURE__*/getDefaultExportFromCjs(isRetryAllowedExports);

export { isRetryAllowed as default };
//# sourceMappingURL=_virtual-index.js.map
